module.exports = __webpack_public_path__ + "static/media/41pic.7368af60.jpg";